import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Breadcrumb from "../components/breadcrumb"
import PostHeader from "../components/post-header"
import PostFooter from "../components/post-footer"
import PostToc from "../components/post-toc"
import Seo from "../components/seo"
import AdsenseMultiplex from "../components/adsenseMultiplex"

import "../styles/pochipp/dist/css/style.css"
import "../styles/snow-monkey-blocks/dist/css/fallback.css"
import "../styles/snow-monkey-blocks/alert/style.css"
import "../styles/snow-monkey-blocks/balloon/style.css"
import "../styles/snow-monkey-blocks/step/style.css"
import "../styles/snow-monkey-editor/dist/css/editor.css"

const SinglePage = ({ data, pageContext, location }) => {
  return (
    <Layout>
      <Breadcrumb
        title={data.markdownRemark.frontmatter.title}
        category={{
          slug: data.markdownRemark.frontmatter.categories[0].slug,
          title: data.markdownRemark.frontmatter.categories[0].title,
        }}
      />
      <div className="l-content__body l-container page-template-one-column-slim">
        <main id="main_content" className="l-main l-article">
          <article className="l-main__body">
            <PostHeader frontmatter={data.markdownRemark.frontmatter} />
            <PostToc toc={data.markdownRemark.tableOfContents} />
            <div
              className="c-postContent p-entry__content"
              dangerouslySetInnerHTML={{
                __html:
                  `<p style="font-size: 0.8em;font-style: italic;color: gray;">
                ※外部サイトへのリンクにはアフィリエイトタグが含まれている場合があり、購入や会員登録の成約などから、当サイトが収益化を行うことがあります。詳細は<a href="/privacy-policy/">プライバシーポリシー</a>をご確認ください。</p>` +
                  data.markdownRemark.html,
              }}
            />
            <PostFooter
              pageContext={pageContext}
              frontmatter={data.markdownRemark.frontmatter}
              relatedPosts={data.allMarkdownRemark.nodes}
            />
            <AdsenseMultiplex path={location.pathname} />
          </article>
        </main>
      </div>
    </Layout>
  )
}

export const Head = ({ data, location }) => {
  const siteUrl = data.site.siteMetadata.siteUrl
  const pagepath = location.pathname
  const pagetitle = data.markdownRemark.frontmatter.title
  const schema = [
    {
      "@type": "Article",
      "@id": `${siteUrl}${pagepath}#article`,
      isPartOf: {
        "@id": siteUrl + pagepath,
      },
      author: {
        name: data.site.siteMetadata.author,
        "@id": `${siteUrl}/#/schema/person/5eb9322a37185f2d4cc6ddaa45c210b2`,
      },
      headline: pagetitle,
      datePublished: data.markdownRemark.frontmatter.date,
      dateModified: data.markdownRemark.frontmatter.lastmod,
      mainEntityOfPage: {
        "@id": siteUrl + pagepath,
      },
      wordCount: data.markdownRemark.wordCount.words,
      publisher: {
        "@id": `${siteUrl}/#/schema/person/5eb9322a37185f2d4cc6ddaa45c210b2`,
      },
      image: {
        "@id": `${siteUrl}${pagepath}#primaryimage`,
      },
      thumbnailUrl:
        siteUrl +
        (data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.url || data.file.childImageSharp.original.src),
      keywords:
        data.markdownRemark.frontmatter.tags?.map(tag => tag.title) || "",
      articleSection: data.markdownRemark.frontmatter.categories.map(
        category => category.title,
      ),
      inLanguage: "ja",
    },
    {
      "@type": "WebPage",
      "@id": siteUrl + pagepath,
      url: siteUrl + pagepath,
      name: `${pagetitle} | ${data.site.siteMetadata.title}`,
      isPartOf: {
        "@id": `${siteUrl}${pagepath}#website`,
      },
      primaryImageOfPage: {
        "@id": `${siteUrl}${pagepath}#primaryimage`,
      },
      image: {
        "@id": `${siteUrl}${pagepath}#primaryimage`,
      },
      thumbnailUrl:
        siteUrl +
        (data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.url || data.file.childImageSharp.original.src),
      datePublished: data.markdownRemark.frontmatter.date,
      dateModified: data.markdownRemark.frontmatter.lastmod,
      breadcrumb: {
        "@id": `${siteUrl}${pagepath}#breadcrumb`,
      },
      inLanguage: "ja",
      potentialAction: [
        {
          "@type": "ReadAction",
          target: [siteUrl + pagepath],
        },
      ],
    },
    {
      "@type": "ImageObject",
      inLanguage: "ja",
      "@id": `${siteUrl}${pagepath}#primaryimage`,
      url:
        siteUrl +
        (data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.url || data.file.childImageSharp.original.src),
      contentUrl:
        siteUrl +
        (data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.url || data.file.childImageSharp.original.src),
      width:
        data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.width || data.file.childImageSharp.original.width,
      height:
        data.markdownRemark.frontmatter.image?.childImageSharp?.original
          ?.height || data.file.childImageSharp.original.height,
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${siteUrl}${pagepath}#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "ホーム",
          item: siteUrl,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: data.markdownRemark.frontmatter.categories[0].title,
          item: `${siteUrl}/${data.markdownRemark.frontmatter.categories[0].slug}/`,
        },
        {
          "@type": "ListItem",
          position: 3,
          name: pagetitle,
        },
      ],
    },
  ]
  return (
    <Seo
      pagetitle={pagetitle}
      pagedesc={data.markdownRemark.excerpt}
      pagepath={pagepath}
      pagetype="article"
      pageimg={
        data.markdownRemark.frontmatter.image?.childImageSharp.original.src
      }
      pageimgw={
        data.markdownRemark.frontmatter.image?.childImageSharp.original.width
      }
      pageimgh={
        data.markdownRemark.frontmatter.image?.childImageSharp.original.height
      }
      pageSchema={schema}
    />
  )
}

export const query = graphql`
  query ($id: String!, $catId: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        date
        dateJP: date(formatString: "YYYY.M.D")
        lastmod
        lastmodJP: lastmod(formatString: "YYYY.M.D")
        image {
          childImageSharp {
            gatsbyImageData(width: 960, placeholder: BLURRED)
            original {
              width
              height
              src
            }
          }
        }
        categories {
          slug
          title
        }
        tags {
          slug
          title
        }
      }
      html
      excerpt(pruneLength: 140, truncate: true)
      tableOfContents(maxDepth: 3)
      wordCount {
        words
      }
    }
    allMarkdownRemark(
      filter: {
        id: { ne: $id }
        frontmatter: {
          categories: { elemMatch: { id: { eq: $catId } } }
          draft: { ne: true }
        }
      }
      sort: { frontmatter: { lastmod: DESC } }
      limit: 4
    ) {
      nodes {
        id
        frontmatter {
          title
          date
          dateJP: date(formatString: "YYYY.M.D")
          lastmod
          lastmodJP: lastmod(formatString: "YYYY.M.D")
          image {
            childImageSharp {
              gatsbyImageData(width: 240, placeholder: BLURRED)
            }
          }
          categories {
            title
          }
        }
        excerpt(pruneLength: 80, truncate: true)
        parent {
          ... on File {
            name
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        author
      }
    }
    file(name: { eq: "noimg" }) {
      childImageSharp {
        original {
          width
          height
          src
        }
      }
    }
  }
`

export default SinglePage
